export default __webpack_public_path__ + "static/media/TokiRGB_white.3d74a50a.png";